import axios from "axios";
import FeatherIcon from 'feather-icons-react';
import React, {Component} from "react";
import ReactToPrint from "react-to-print";
import Headerpdf from "../../users/Headerpdf";
import UserIdentity from "../../users/UserIdentity";

class   Accountingbalance extends Component{

    state = {
        isModal : false,
        formData : null,
        loading : false,
        monthId : null,
        chartacountId : null,
        accountingbalances : [],
        accountingbalances : [],
        months : [
            { id : 5, month : 'Janvier'},  
            { id : 6, month : 'Fevrier' },  
            { id : 7, month : 'Mars' },  
            { id : 8, month : 'Avril' },  
            { id : 9, month : 'Mai' },  
            { id : 10, month : 'Juin' },  
            { id : 11, month : 'Juillet' },  
            { id : 12, month : 'Aout' },  
            { id : 1, month : 'Septembre' },  
            { id : 2, month : 'Octombre' },  
            { id : 3, month : 'Novembre' },  
            { id : 4, month : 'Decembre' } ],                            
        periods : ['','Septembre', 'Octombre', 'Novembre', 'Decembre', 'Janvier','Fevrier','Mars','Avril','Mai','Juin','Juillet', 'Aout', ]
    }

    componentDidMount(){
        var commitment_date = new Date();
        commitment_date = commitment_date.getMonth();
        this.setState({
            monthId : this.state.months[commitment_date]?.id
        })
        this.getAccountingbalances(commitment_date);
    }

    handleInput = (e) => {
        this.getAccountingbalances(e.target.value);
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    async getAccountingbalances(commitment_date){
        this.setState({accountingbalances : [] , loading : false}) 
        var accountingbalances = await axios.get('accountingbalances/' + commitment_date);
        if(accountingbalances.status === 200)
        {
            this.setState({ accountingbalances : accountingbalances.data , loading : true}) 
        }
    }

    render(){
        var amount = "", currency = [], chartacount = [{ id: null, chartaccount : ""}];
        this.state.accountingbalances.map(curr => {
            if(currency.filter(dat => dat.currency == curr.chartaccount.currency).length == 0){
                currency.push({
                    amount : 0,
                    currency : curr.chartaccount.currency
                })
            }

            if(chartacount.filter((val) => val.id == curr.chartaccount.id)?.length == 0){
                chartacount.push({
                    id : curr.chartaccount?.id,
                    chartaccount : curr.chartaccount.wording
                })
            }

        })
        return(
            <div className="overflow-hidden">
            <div className="align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h5 className="h5 font-monospace">Equilibre du caisse mois <span className="text-primary"> { this.state.months?.filter(val => val.id == this.state.monthId)[0]?.month}  </span></h5>
                
                <div className="text-end">
                    
                    <select name="monthId" value={ this.state.monthId} className="me-2 text-primary" onChange={this.handleInput}>
                        {
                            this.state.months.map((month) => {
                                return(
                                    <option value={month.id}>{ month.month }</option>
                                )
                            })
                        }
                    </select>

                    <select name="chartacountId" value={ this.state.chartacountId} className="me-2 text-primary" onChange={(e) => this.setState({ chartacountId : e.target.value})}>
                        {
                            chartacount.map((va) => {
                                return(
                                    <option value={va.id}>{ va.chartaccount }</option>
                                )
                            })
                        }
                    </select>

                    <ReactToPrint
                        trigger={() => <button className="btn btn-sm btn-outline-primary" type="button"><FeatherIcon icon={"printer"} size="22"></FeatherIcon> <span className="d-none d-sm-inline">Imprimer</span></button>}
                        content={() =>  this.componentRef}
                    />
                </div>
            </div>
            <div  ref={el => (this.componentRef = el)}>
                    <Headerpdf />
                    <UserIdentity title={ "Equilibre du caisse " + this.state.monthId + " ° mois"} />
            <div className="table-responsive">
                <table className="table table-striped table-sm table-bordered ">
                <thead>
                    <tr>
                        <th>#</th>
                        <th scope="col">Caisse</th>
                        <th scope="col">Débiter</th>
                        <th scope="col">Créditer</th>
                        <th scope="col">Solde</th>
                        <th scope="col">Mois</th>
                        <th scope="col">Date</th>
                        <th scope="col">Motif</th>
                        <th scope="col">Opérateur</th>
                    </tr>
                </thead>
                <tbody style={{  fontSize : 13 +"px" }}>
                    { !this.state.loading && (<FeatherIcon className="user-search-spin" icon="loader" />)}
                    {
                        this.state.accountingbalances?.filter(val => val.chartaccount.id == this.state.chartacountId || this.state.chartacountId == null).map((accountingbalance, count) => {
                            amount = "";
                            currency.map((curr, index) => {
                                if(curr.currency == accountingbalance.chartaccount.currency)
                                {
                                    currency[index].amount =  accountingbalance.debit > 0 ? currency[index].amount + accountingbalance.debit : currency[index].amount - accountingbalance.credit;
                                    amount = currency[index].amount > 0 ? currency[index].amount?.toLocaleString() + "" + accountingbalance.chartaccount.currency : "";  
                                }
                            })
                            
                            return(
                                <tr key={accountingbalance.id}>
                                    <td align="right">{count + 1 }</td>
                                    <td align="center">{accountingbalance.chartaccount.wording}</td>
                                    <td align="right">{accountingbalance.debit > 0 ? (accountingbalance.debit)?.toLocaleString()+""+accountingbalance.chartaccount.currency : ""}</td>
                                    <td align="right">{accountingbalance.credit > 0 ? (accountingbalance.credit)?.toLocaleString()+""+accountingbalance.chartaccount.currency : ""}</td>
                                    <td align="right">{amount?.toLocaleString()}</td>
                                    <td align="center">
                                        {accountingbalance.expensedetail ? accountingbalance.expensedetail.expense.month ? accountingbalance.expensedetail.expense.month.month + " " + accountingbalance.expensedetail.expense.year.year  : "" : ""}
                                        {accountingbalance.schoolfee ? accountingbalance.schoolfee.month ? accountingbalance.schoolfee.month.month + " " + accountingbalance.schoolfee.year.year : "" : ""}
                                    </td>
                                    <td align="center">{new Date(accountingbalance.createdAt).toLocaleDateString("en-GB")}</td>
                                    <td>
                                        { accountingbalance.expensedetail ? accountingbalance.expensedetail.typesalary ? accountingbalance.expensedetail.typesalary.type : accountingbalance.expensedetail.reason : "" }
                                        { accountingbalance.schoolfee ? accountingbalance.schoolfee.sectionschoolfeecategory ? accountingbalance.schoolfee.sectionschoolfeecategory.schoolfeecategory.category : "" : "" }
                                         _ { accountingbalance.schoolfee?.trimesectschool?.trimester?.short_trimester}
                                        { (accountingbalance.expensedetail == null && accountingbalance.schoolfee == null) ? "Depense" : "" }
                                    </td>
                                    <td align="">
                                    {accountingbalance.expensedetail ? 
                                        <span>
                                            {accountingbalance.expensedetail.staff && (accountingbalance.expensedetail.staff.user.last_name +" "+ accountingbalance.expensedetail.staff.user.first_name)}
                                        </span>
                                     : ""}
                                        {accountingbalance.schoolfee ? 
                                            <span>
                                                {accountingbalance.schoolfee.staff && (accountingbalance.schoolfee.staff.user.last_name +" "+ accountingbalance.schoolfee.staff.user.first_name)}
                                            </span>
                                         : ""}
                                    </td>
                                    
                                </tr>
                            )
                        })
                    }
                </tbody>
                </table>
            </div>
            </div>

            
        </div>
        )
    }
}
export default Accountingbalance;